import { Component, Input, OnInit } from '@angular/core';

import { IProductos } from '../../../../private/shared/models/productos';

@Component({
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.scss'],
})
export class SummaryComponent implements OnInit {

  @Input() exchange = 0;
  @Input() productosPromocion: IProductos[] = [];
  @Input() isBonus = false;

  constructor() { }

  ngOnInit() { }

}
